import './style.scss';
import IconButton from './iconbutton.js';

export default IconButton;